const USERS_SOURCES =
    Object.freeze(
        {
            REGISTRATION: 1,
            BULK_UPLOAD: 2,
            CREATED_BY_MANAGER: 3,
            NRWEROTIK: 4,
            VIA_CC: 5,
            ITR: 6,
            ASIA: 7,
            BANDIVA: 8,
            DISKRET: 9,
        }
    );

export default USERS_SOURCES;
